import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../../services/http-client.service';
import { WebsiteThemeService } from '../../../services/website-theme.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AuthService } from "../../../services/auth.service";
import { WebClientService } from "../../../services/webclient-settings.service";
import { ComponentService } from "../../../services/component.service";
import { AdditionalTransactionInfoModalComponent } from "../additional-transaction-info-modal/additional-transaction-info-modal.component";
import { BankaccountWhitelistInfoComponent } from "../bankaccount-whitelist-info/bankaccount-whitelist-info.component";
/**
 * Wallet Transactions Component
 */
let WalletTransactionsComponent = class WalletTransactionsComponent {
    constructor(httpClient, sanitizer, themeService, router, webSettingsService, auth, compService) {
        this.httpClient = httpClient;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.router = router;
        this.webSettingsService = webSettingsService;
        this.auth = auth;
        this.compService = compService;
        this.backColor = '';
        this.accentColor = '';
        this.mainColor = '';
        this.borderRadiusLarger = '';
        this.borderRadiusSmaller = '';
        this.textColor = '';
        this.errorColor = '';
        this.successColor = '';
        this.secondaryColor = '';
        this.linkColor = '';
        this.inputBackColor = '';
        this.searchCrypto = '';
        this.user = JSON.parse(localStorage.getItem('user'));
        this.transactions = [];
        this.allTransactions = [];
        this.page = 0;
        this.transactionsLoaded = false;
        this.copied = false;
        this.defaultCurrency = localStorage.getItem('defaultCurrency');
        this.waitingForApprovalStatus = 'WAITING_FOR_APPROVAL';
        this.loadMoreTx = false;
        this.auth.fetchUser().then(result => {
            this.user = JSON.parse(localStorage.getItem('user'));
            if (!this.user || !this.user.eligible_for_wallet ||
                (!this.user.personally_validated && this.user.user_type_id.type !== 'lite_verified') || this.user.api_mfa_enabled != 1) {
                this.router.navigateByUrl('');
            }
        });
        this.themeService.getTheme().subscribe((data) => {
            this.backColor = this.themeService.getStyleAttribute('side_menu');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.mainColor = this.themeService.getStyleAttribute('main_color');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
            this.linkColor = this.themeService.getStyleAttribute('link_color');
            this.inputBackColor = this.themeService.getStyleAttribute('input_background_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.secondaryColor = this.themeService.getStyleAttribute('secondary_text_color');
        });
    }
    ngOnInit() {
        this.webSettingsService.getSettings().subscribe((data) => {
            if (data['settings']) {
                this.sliceFromSetting = Number(data['settings']['WALLET.PAGINATION.NUMBER_OF_TRANSACTIONS']);
                this.getTransactions();
            }
        });
        this.httpClient.get('user/getbankaccounts').subscribe((result) => {
            this.bankAccounts = result;
        });
    }
    ngOnDestroy() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    }
    reloadTransactions() {
        this.getTransactions(true);
    }
    showMore() {
        this.loadMoreTx = true;
        this.page++;
        this.getTransactions();
    }
    searchCryptocurrency() {
        this.transactions = this.allTransactions;
        this.transactions = this.allTransactions.filter(transaction => (((transaction.currency.name.toLowerCase().includes(this.searchCrypto.toLowerCase())) || transaction.currency.verboseId.toLowerCase().includes(this.searchCrypto.toLowerCase()))));
    }
    getTransactions(refresh = false) {
        if (this.intervalId) {
            clearTimeout(this.intervalId);
        }
        const page = refresh ? 0 : this.page;
        const limit = refresh ? ((this.page + 1) * this.sliceFromSetting) : this.sliceFromSetting;
        this.httpClient.get('v2/wallet/gettransactions?page=' + page + '&limit=' + limit).subscribe((transactions) => {
            this.paginationData = transactions['paginationData'];
            const tempTransactions = [];
            if (transactions['transactions']) {
                for (let i = 0; i < transactions['transactions'].length; i++) {
                    const transaction = transactions['transactions'][i];
                    const tempData = {
                        transaction,
                        order: transaction['order'] || null,
                        colorClass: null,
                        progressValue: null
                    };
                    if (transaction.hasOwnProperty('externalOrderId') && transaction.hasOwnProperty('order') && transactions['transactions'][i]['type'] != 'REWARD') {
                        const order = tempData.order;
                        if (order['status'] === 'Poništena') {
                            tempData.colorClass = 'red-progress-bar';
                        }
                        else if (order['status'] === 'Realizovana') {
                            tempData.colorClass = 'green-progress-bar';
                        }
                        else if (order['progress'] === 33 || order['progress'] === 66) {
                            tempData.colorClass = 'yellow-progress-bar';
                        }
                        else {
                            tempData.colorClass = 'yellow-progress-bar';
                        }
                        tempData.progressValue = order['progress'];
                        tempTransactions.push(tempData);
                    }
                    else {
                        // deposit, withdraw or reward
                        switch (transaction['status']) {
                            case 'REJECTED':
                            case 'CANCELLED':
                            case 'EXPIRED':
                            case 'FAILED': {
                                tempData.progressValue = 100;
                                tempData.colorClass = 'red-progress-bar';
                                break;
                            }
                            case 'DONE': {
                                tempData.progressValue = 100;
                                tempData.colorClass = 'green-progress-bar';
                                break;
                            }
                            case 'TO_BE_PROCESSED':
                            case 'PENDING': {
                                tempData.progressValue = 50;
                                tempData.colorClass = 'yellow-progress-bar';
                                break;
                            }
                            default: {
                                tempData.progressValue = 100;
                                tempData.colorClass = 'gray-progress-bar';
                            }
                        }
                        tempTransactions.push(tempData);
                    }
                }
            }
            if (refresh || this.page === 0) {
                this.transactions = tempTransactions;
            }
            else {
                this.transactions = [...this.transactions, ...tempTransactions];
            }
            this.allTransactions = this.transactions;
            this.transactionsLoaded = true;
            this.loadMoreTx = false;
            this.intervalId = setTimeout(() => {
                this.getTransactions(true);
            }, 15000);
        }, error => {
            this.intervalId = setTimeout(() => {
                this.getTransactions(true);
            }, 15000);
        });
    }
    goToBlockExplorer(blockExplorerLink, isFiat) {
        if (!isFiat) {
            window.open(blockExplorerLink, '_blank');
        }
    }
    copyAddress(address) {
        document.addEventListener('copy', (e) => {
            e.clipboardData.setData('text/plain', (address));
            e.preventDefault();
            document.removeEventListener('copy', null);
        });
        document.execCommand('copy');
        this.copied = true;
        setTimeout(() => {
            this.copied = false;
        }, 2000);
    }
    showAddressWithEllipsis(address) {
        if (address.length > 20) {
            return address.substr(0, 10) + '...' + address.substr(address.length - 10, address.length);
        }
        return address;
    }
    goToAdditionalInformationModal(data) {
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
        this.compService.openModal(AdditionalTransactionInfoModalComponent, {
            txData: data
        }, (success) => {
            if (success.dataUpdated) {
                const transaction = this.transactions.find(tx => tx.transaction.id === data.transaction.id);
                transaction.transaction.travelRuleDataProvided = 1;
            }
            this.reloadTransactions();
        });
    }
    addNewBankAccount() {
        this.compService.openModal(BankaccountWhitelistInfoComponent, {
            pendingProcess: this.bankAccounts.some(account => account.status === this.waitingForApprovalStatus),
        });
    }
};
WalletTransactionsComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: Router },
    { type: WebClientService },
    { type: AuthService },
    { type: ComponentService }
];
WalletTransactionsComponent = __decorate([
    Component({
        selector: 'ecd-wallet-transactions',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./wallet-transactions.component.html")).default
    })
], WalletTransactionsComponent);
export { WalletTransactionsComponent };
